import styled from "styled-components";

export const WhiteBox = styled.div`
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 3px 5px 1px rgba(0, 0, 0, 0.05);
    padding: 10px;
    margin: 5px;
    min-height: 98%;
`